import {Analytics} from '../../shared/js/Analytics';
window.Analytics = Analytics;